import { ENTITY_MAP } from '../../app/app.config.entity-map';
import { BaseObject } from '../business-objects/base-object/base-object.model';

export const getInstanceName = (instance: BaseObject): string => {

    if (!instance) {
        throw Error(`instance is not an instance of BaseObject`);
    }

    for (const name in ENTITY_MAP) {
        if (instance instanceof ENTITY_MAP[name]) {
            return name;
        }
    }

    throw Error('instance name not found');
};



// WEBPACK FOOTER //
// ./src/core/util/get-instance-name.ts